export default __webpack_public_path__ + "static/media/BOD Regular Meeting February 17, 2020.2811a682.pdf";